import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  createStaticText, getStaticTextByKey, getStaticTexts, updateStaticText,
} from '../../axios/staticTextRequests';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  getHeader,
} from '../../helperFunctions/getHeader';
import {
  IStaticTextStore, StaticText, STATIC_TEXT_APP, GetStaticTextsOptions, StaticTextStatus
} from '../storeInterfaces/staticTextInterface';
import { RequestStatus } from 'mobx-store';

export class StaticTextStore implements IStaticTextStore {
  @observable staticTextsList: StaticText[] = [];

  @observable selectedStaticText = new StaticText();

  @observable loading = false;

  @observable getStaticTextsRequestStatus: RequestStatus = RequestStatus.IDLE;

  @observable getStaticTextRequestStatus: RequestStatus = RequestStatus.IDLE;

  @observable addEditLoadingState: RequestStatus = RequestStatus.IDLE;

  

  @action
  public async getStaticTexts(app: STATIC_TEXT_APP, options: GetStaticTextsOptions, languageCode: string = DefaultLanguage): Promise<void> {
    try {
      this.loading = true;
      this.getStaticTextsRequestStatus = RequestStatus.LOADING;
      const config = {
        ...getHeader(languageCode),
        params: {
          ...options,
        },
      };
      const response = await Connections.wadiDeglaAxios.httpGet(getStaticTexts(app), config);
      console.log(response);
      this.staticTextsList = this.restructureStaticTextsArray(response.data);
      this.getStaticTextsRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getStaticTextsRequestStatus = RequestStatus.FAILED;
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action
  public async getStaticTextByKey(key: string, app: STATIC_TEXT_APP, languageCode: string = DefaultLanguage): Promise<void> {
    try {
      this.loading = true;
      this.getStaticTextRequestStatus = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(getStaticTextByKey(key, app), getHeader(languageCode));
      this.selectedStaticText = this.restructureStaticText(response.data);
      this.getStaticTextRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      console.log(error);
      this.getStaticTextRequestStatus = RequestStatus.FAILED;
    } finally {
      this.loading = false;
    }
  }

  @action
  public async createStaticText(newStaticText: StaticText, languageCode: string = DefaultLanguage): Promise<any> {
    try {
      this.getStaticTextRequestStatus = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpPost(createStaticText, {
        ...newStaticText, languageCode,
      });
      this.getStaticTextRequestStatus = RequestStatus.SUCCESS;
      return response.data;
    } catch (error) {
      this.getStaticTextRequestStatus = RequestStatus.FAILED;
      console.log(error);
      throw error;
    }
  }

  @action
  public async updateStaticText(updatedStaticText: any, key: string, app: STATIC_TEXT_APP, languageCode?: string | undefined): Promise<any> {
    try {
      this.getStaticTextRequestStatus = RequestStatus.LOADING;
      delete updatedStaticText.key;
      await Connections.wadiDeglaAxios.httpPut(updateStaticText(key, app), {
        ...updatedStaticText, languageCode,
      });
      this.getStaticTextRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getStaticTextRequestStatus = RequestStatus.FAILED;
      console.log(error);
    }
  }

  private restructureStaticText(data: any): StaticText {
    const structuredStaticText: StaticText = new StaticText();
    structuredStaticText.setKey(data.textKey);
    structuredStaticText.setDescription(data.keyDescription);
    structuredStaticText.setValue(data.value);
    structuredStaticText.setCategory(data.categoryName);
    return structuredStaticText;
  }

  private restructureStaticTextsArray(data: any): StaticText[] {
    const incomingData: StaticText[] = [];
    data.forEach((staticText: any) => {
      const staticTextToPush: StaticText = new StaticText();
      staticTextToPush.setKey(staticText.textKey);
      staticTextToPush.setDescription(staticText.keyDescription);
      staticTextToPush.setValue(staticText.value);
      staticTextToPush.setCategory(staticText.categoryName);
      incomingData.push(staticTextToPush);
    });
    return incomingData;
  }
}
